import * as React from 'react';

import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { useMessage } from '../context/MessageProvider';

import Container from '@mui/material/Container';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2


import {useForm, FormProvider} from 'react-hook-form';
import Form from '../components/form/Form';
import FormDropDownAndUsed from '../components/form/FormDropDownAndUsed';
import FormButton from '../components/form/FormButton';

import Header from "../components/Header";
import Subtitle from "../components/Subtitle";
import GoBack from "../components/GoBack";
import Spinner from "../components/Spinner";

import { newSectionA, saveSectionA, listSectionAsByAssessment } from '../models/sectiona';
import { listAnimals } from '../models/animals';
import { getFacility } from '../models/facility';
import { getAssessment } from '../models/assessments';


import {today, workdayTimeRanges} from "../utils/datetime";
import { findModel } from '../utils/model';

import { useQuery } from '@tanstack/react-query'

import { useConnectivity } from '../context/ConnectivityProvider';


export default function AssessmentSectionASelectPage({title = "EWP",...props}) {

    const {setSuccess, setError} = useMessage();
    //const {facility, animals, assessment, sectionBs, newSectionB} = useLoaderData(); 
    const navigate = useNavigate();
    const params = useParams();
    const {isOnline} = useConnectivity();

    const {isLoading, data} = useQuery({
        queryKey: ['sectiona',params.assessmentId],
        queryFn: async() => {

            const animals = await listAnimals();
            const assessment = await getAssessment(params.assessmentId);
            return {
                facility: await getFacility(), 
                animals,
                assessment,
                sectionAs: await listSectionAsByAssessment(params.assessmentId),
                newSectionA: newSectionA(),
                animal: findModel(animals,assessment.animal_id),
            };
        },
        networkMode: "offlineFirst",
    });


    let observationWindows = [];
    let sectionList = [];
    let usedList = [];
    if (data) {

        const {facility, animals, sectionAs, newSectionA, assessment} = data;

        console.log("section a assessment id: ", params.assessmentId);
        console.log("facility: ", facility, "animals:", animals);
        console.log("sectionAs: ", sectionAs);
        console.log("newSectionA", newSectionA);

        const startOfDay = assessment?.start_of_day || facility?.start_of_day;
        const endOfDay = assessment?.end_of_day || facility?.end_of_day;
        if (startOfDay && endOfDay) {
            observationWindows = workdayTimeRanges(startOfDay, endOfDay);
        }
        console.log(observationWindows);

        sectionList = sectionAs.map((cur)=>{
            return {
                value: cur.id,
                label: cur.observation_range,
            };
        });

        usedList = (sectionAs || []).filter((cur)=>{
            return cur.submitted_on
        }).map((cur)=>cur.id);
    }

    const onSubmit = async (inputData) => {
        try {
            console.log("onSubmit", inputData);

            const record = (data?.sectionAs || []).find((cur)=>cur.id === inputData.id);
            if (record === null) {
                throw new Error("Could not locate a section record with id: " + inputData.id);
            }

            console.log('matched record', record);


            const payload = {...record,observed_on: today()};
            console.log("payload: ", payload);
            const saveResult = await saveSectionA(payload,isOnline);
            console.log("sectiona save: ", saveResult);

            setSuccess("Started Section A");
            navigate("/assessments/" + data.assessment.id + "/sectiona/" + record.id);

        } catch(error) {
            console.error(error);
            setError(error.message);
        }

    }

    console.log("usedList:", usedList);

    const defaultValues = {id: ''};
    const formProps = { defaultValues };
	const methods = useForm(formProps);

    // note you can play with the container maxwidth to spread out the window content appears in
    return (
        <Container component="main" maxWidth="sm">
            {isLoading && <Spinner />}
            {!isLoading && <>
                <GoBack onClick={()=>navigate(`/assessments/${data.assessment.id}`)} />
                <Header label={title} />
                <Subtitle>{data?.assessment?.assessment_title || data?.animal?.name}</Subtitle>

                <FormProvider {...methods}>
                    <Form onSubmit={methods.handleSubmit(onSubmit)}>
                        <Grid container spacing={2}>
                            <Grid xs={12} sm={12} sx={{justifyContent: "center", alignItems: "center"}}> 
                                <FormDropDownAndUsed name="id" label="Observation Timeframe" list={sectionList} required usedList={usedList} />
                            </Grid>

                            <Grid xs={12} sm={12}> 
                                <FormButton>Start</FormButton>
                            </Grid>
                        </Grid>

                    </Form>
                </FormProvider>

            </>}
        </Container>
    );
}

/*
                */
